import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { FULL_GATEWAY_ROUTE_PATHS } from './config';

export const FULL_GATEWAY_ROUTES: TApplicationRoute[] = [
  {
    id: 'movements-full-gateway',
    path: FULL_GATEWAY_ROUTE_PATHS.fullGateway,
    component: lazy(() => import('./pages/full-gateway-page')),
    layout: 'default',
    permissions: { scopes: ['movements-full-gateway'] },
    menu: {
      title: 'Full Gateway',
    },
  },
];